<template>
  <section>
    <v-dialog v-model="dialog" persistent max-width="750px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
            <v-flex>Set Referral Rules</v-flex>
            <v-btn icon @click="CloseDialog">
                <v-icon color="text--secondary">close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex wrap style="padding: 10px;">
            <v-flex>
                <v-text-field v-model="Reward_Points" label="Reward Points"></v-text-field>
                </v-flex>
                <v-flex>
                <v-text-field v-model="Maximum_Referrals" label="Number Of Maximum Referrals"></v-text-field>
                </v-flex>
            </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-flex style="text-align: right;">
            <v-btn color="success" @click="SubmitPromotionalOffer">Set Referral Rules</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
export default {
  props: ["dialog"],
  data() {
    return {

      Reward_Points         :  0,
      Maximum_Referrals     :  0,
      
    };
  },
  methods: {
    CloseDialog() {

      this.ClearForm();
      this.$emit("close");
    },
    SubmitPromotionalOffer() {

      if (this.Reward_Points && this.Maximum_Referrals) {

        let data  = { "Reward_Points" :  parseInt(this.Reward_Points) , "Maximum_Referrals" : parseInt(this.Maximum_Referrals)}
        this.$http.post(`${this.$store.getters.GetProductionUrl}/offers/setreferalrules`,data)
                  .then(response => {
                      
                      this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Successfully Set Referral Rules", Color: "green",Close: false});
                      this.CloseDialog();
                  })
                  .catch(err => {

                      this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Set Referral Rules", Color: "red", Close: false });
                  });

      } else {
         
        this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Fill The Complete Form Details",
                                            Color: "red", Close: false
                                          });
      }
    },
    ClearForm() {
      
      this.Reward_Points     = ""
      this.Maximum_Referrals = ""
      
    },
    GetCurrentDetails() {

        this.$http.post(`${this.$store.getters.GetProductionUrl}/offers/getreferalrules`)
                  .then(response => {
                    
                      this.Reward_Points     = response['data']['response'] && response['data']['response']['Reward_Points'] ? response['data']['response']['Reward_Points'] : 0
                      this.Maximum_Referrals = response['data']['response'] && response['data']['response']['Maximum_Referrals'] ? response['data']['response']['Maximum_Referrals'] : 0
                  })
                  .catch(err => {

                      this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error While Getting Referral Rules", Color: "red", Close: false });
                  });

    }
  }
};
</script>
<style scoped>
</style>